import { useEffect } from "react";
import ReactSummernote from "react-summernote";
export const Editor = (props) => {

    useEffect(() => {
     
    }, [props.editorData]);
    
    return (

        <ReactSummernote
            options={{
                disableDragAndDrop: true,
                height: 500,
                toolbar: [
                    ['style', ['bold', 'italic', 'underline', 'clear']],
                    ["font", ['strikethrough', 'superscript', 'subscript']],
                    ['fontsize', ['fontsize']],
                    ["fontname", ["fontname"]],
                    ['height', ['height']],
                    ["para", ["ul", "ol", "paragraph"]],
                    ["table", ["table"]],
                    ["insert", ["link", "picture", "video"]],
                    ["view", ["fullscreen", "codeview"]],
                    ['color', ['color']],
                ]
            }}
            // className="m-4"
            value={props.editorData}
        
            onChange={(e) => props.onChange(e)}

        />
    )
}
